//export const URI =  'http://localhost:5000/';

export const URI = process.env.REACT_APP_API_BASE_URL + '/';

//server droplet
//export const URI =  '/';

const API_URL = {
   
    'POST_ADMIN_LOGIN': URI + 'api/adminuser/login',
    'POST_ADMIN_CREATE': URI + 'api/adminuser/create',
    'GET_ADMIN_ALL': URI + 'api/adminuser/',
    'DELETE_ADMIN': URI + 'api/adminuser/',
    'ADMIN_MANAGE_ALL_USERS' : URI + 'api/user/adminallusers',
    'ADMIN_UPDATE_SUBSCRIPTION' : URI + 'api/user/adminupdatesubscription/',
    'ADMIN_UPDATE_WORKOUT' : URI + 'api/user/adminupdateworkout/',
    'ADMIN_GET_ALL_WORKOUTS' : URI + 'api/workoutmaster/getallworkoutsadmin',
    ADMIN_GET_WORKOUT_BY_ID : URI + 'api/workoutmaster/getworkoutbyid/',


    'ADMIN_SAVE_WORKOUT' : URI + 'api/workout/adminsaveworkout',
    'ADMIN_MANAGE_WORKOUT' : URI + 'api/workout/adminmanageworkout',
    'ADMIN_DELETE_WORKOUT' : URI + 'api/workout/admindeleteworkout/',



    'FRONTEND_GOOGLE_LOGIN' : URI + 'api/user/googlelogin',
    'GET_TELEGRAM_LINK': URI + 'api/user/telegram-link',
    'GET_ME' : URI + 'api/user/me',
    'FRONTEND_GET_ALL_WORKOUTS' : URI + 'api/workoutmaster/getallworkouts',
    'FRONTEND_GET_ENROLLMENTS' : URI + 'api/user/getuserenrollmentsdata',



    'FRONTEND_UPDATE_USER_RESPONSE' : URI + 'api/user/updateuserworkoutresponse',

    'FRONTEND_GET_USER_RESPONSE_PAGE_DATA' : URI + 'api/user/getuserworkoutresponsepagedata',

 }

Object.freeze(API_URL);

export default API_URL;
